import type { LookoRouteObject } from '../LookoRouteObject';

export const 인증_라우터 = {
  비밀번호_찾기: {
    path: '/find-password',
    async lazy() {
      const { default: Page } = await import('@/router/auth/비밀번호_찾기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: 'Looko-AI 비밀번호 찾기',
    },
  } satisfies LookoRouteObject,
};

export const 인증_라우터_루트: LookoRouteObject[] = [...Object.values(인증_라우터)];
